var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemoveIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Add History"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10.5,
    cy: 10.5,
    r: 9,
    fill: "#ADADAD"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Add History_2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval_2",
    cx: 10.5,
    cy: 10.5,
    r: 9,
    fill: "white",
    stroke: "#ADADAD"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 5821",
    x: 6.66357,
    y: 11.8271,
    width: 2.58182,
    height: 7.74546,
    rx: 0.860606,
    transform: "rotate(-90 6.66357 11.8271)",
    fill: "#ADADAD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/remove-icon.a41c3fcac2c22cc8305770a4aab7cf27.svg";
export { ForwardRef as ReactComponent };